<div class="modal-header">
  <h3 class="modal-title light-color-primary" i18n="@@evolviSeatMap">Seatmap</h3>
  <button
    type="button"
    class="close"
    aria-label="Close Seatmap"
    ngbAutoFocus
    (click)="dialogRef.close()"
    (keydown.enter)="dialogRef.close()"
    (keydown.space)="dialogRef.close()"
  >
    <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
  </button>
</div>

<div class="modal-body">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="seatmap-tabs">
    @for (seatMap of seatMaps; track seatMap; let i = $index) {
      <!-- ! - Need better seatmap labelling -->
      <mat-tab role="tabpanel" label="{{ seatMap.description }}">
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          class="seatmap-tabs"
          [selectedIndex]="selectedIndices[seatMap.legId]"
        >
          @if (!seatMap.coaches?.length) {
            <span class="error">No Seatmaps available for {{ seatMap.description }}</span>
          }

          @for (coach of seatMap.coaches; track coach) {
            <mat-tab role="tabpanel" label="{{ coach.id }}">
              @if (releventLegs[seatMap.legId]) {
                <app-evolvi-seatmap-coach
                  [releventLeg]="releventLegs[seatMap.legId]"
                  [maxSeats]="maxSeats"
                  [coachDetails]="coach"
                  [defaultChosenSeat]="defaultChosenSeats[seatMap.legId]"
                  [key]="seatMap.legId"
                  [isLeftDirection]="seatMap.isLeftDirection"
                  [seatMapReversed]="seatMap.isReversed"
                  (chosenSeat)="
                    chooseSeat({ chosenSeat: $event, chosenCoach: coach, legId: seatMap.legId })
                  "
                  [reservedSeats]="reservedSeats"
                >
                </app-evolvi-seatmap-coach>
              }
            </mat-tab>
          }
        </mat-tab-group>
      </mat-tab>
    }
  </mat-tab-group>
</div>

<div class="modal-footer">
  <div class="key">
    <div class="key-seat">
      <label i18n="@@evolviSeatMapSelectable">Selectable Seat</label>
      <div class="seat selectable-seat">
        <fa-icon aria-hidden="true" [icon]="faSeatAirline"></fa-icon>
      </div>
    </div>
    <div class="key-seat">
      <label i18n="@@evolviSeatMapChosen">Selected Seat</label>
      <div class="seat chosen-seat">
        <fa-icon aria-hidden="true" [icon]="faSeatAirline"></fa-icon>
      </div>
    </div>
    <div class="key-seat">
      <label i18n="@@evolviSeatMapBlockedOnly">Blocked Seat</label>
      <div class="seat selectable-seat-blocked">
        <fa-icon aria-hidden="true" [icon]="faSeatAirline"></fa-icon>
      </div>
    </div>
    <div class="key-seat">
      <label i18n="@@evolviSeatMapReserved">Reserved Seat</label>
      <div class="seat selectable-seat-reserved">
        <fa-icon aria-hidden="true" [icon]="faSeatAirline"></fa-icon>
      </div>
    </div>
  </div>

  <!-- Disclaimer -->
  <div>
    <p i18n="@@seatMapDiscalimerImage">
      The carriage images and details shown have been supplied by the Train Operating Company;
    </p>
    <p>
      <span i18n="@@seatMapDiscalimerEvolvi">Evolvi Rail Systems</span>
      @if (tmcName) {
        <span>&nbsp;and {{ tmcName }} </span>
      }
      <span i18n="@@seatMapDiscalimerAccept"
        >&nbsp;accepts no liability for the accuracy of this information.</span
      >
    </p>
  </div>

  <div>
    <button
      (click)="resetSeat()"
      appButton="small"
      cdkFocusInitial
      id="resetSeat"
      i18n="@@resetSeat"
      aria-label="Reset Seat(s)"
    >
      Reset Seat
    </button>
    &nbsp;
    <button
      appButton="small"
      (click)="dialogRef.close(chosenSeats)"
      cdkFocusInitial
      id="chooseSeat"
      i18n="@@chooseSeat"
      aria-label="Choose Seat(s)"
    >
      Choose Seat
    </button>
  </div>
</div>
